<template>
  <div
    id="reset-password"
    class="md:tw-w-96 tw-w-11/12 tw-flex tw-flex-col tw-items-center tw-pb-8"
  >
    <OnboardingHeader headerText="Reset your password" />
    <OnboardingSubHeader subHeaderText="Enter a vaild password." />
    <ResetPasswordForm @submitData="submitData" />
    <div class="tw-flex tw-mt-6">
      <p class="tw-text-sm tw-text-gray">Request another link?</p>
      &nbsp;
      <router-link
        to="/onboarding/request-link"
        class="tw-text-sm tw-text-primary"
      >
        Request link
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import OnboardingHeader from "@/components/onboarding/OnboardingHeader.vue";
import OnboardingSubHeader from "@/components/onboarding/OnboardingSubHeader.vue";
import ResetPasswordForm from "@/components/onboarding/forms/ResetPasswordForm.vue";
import { clearStorage } from "@/utils/storage";

export default {
  name: "ResetPassword",

  components: { OnboardingHeader, OnboardingSubHeader, ResetPasswordForm },

  beforeRouteEnter(to, from, next) {
    const { token } = to.query;
    if (!token) {
      clearStorage();
      return next("/onboarding/signin");
    }
    next();
  },

  methods: {
    ...mapActions("organisationModule", ["resetPassword"]),
    ...mapActions("loadingModule", [
      "resetPasswordSuccess",
      "resetPasswordLoading",
    ]),
    ...mapActions(["showToast"]),

    async submitData(payload) {
      this.resetPasswordLoading(true);
      payload.token = this.$route.query.token;
      const response = await this.resetPassword(payload);
      if (response) {
        this.resetPasswordSuccess(true);
        const { message } = response.data;
        this.showToast({
          description: message,
          display: true,
          type: "success",
        });
        this.$router.push("/onboarding/signin");
      }
      this.resetPasswordLoading(false);
    },
  },
};
</script>

<style lang="scss" scoped></style>
